import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initaialState = {
  sales: null,
  salesLoading: false, // Set to false initially since we're not loading data
  inventoryLoading: false,
  itemsSold: 0,
  pendingOrders: 0,
  totalProfit: 0,
  expiringItems: 0,
  itemsInStock: 0,
  stockValue: 0,
  graphLoading: false,
  GraphMetaData: null,
  productsSaleLoading: false,
  productsSale: [],
  performanceProductsSaleLoading: false,
  performanceProductsSale: [],
  chartLoading: false,
  chartData: null,
  chartList: null,
};

const getSalesActivityStart = (state, action) => {
  return updateObject(state, {
    salesLoading: true,
  });
};

const getSalesActivitySuccess = (state, action) => {
  // Dashboard endpoints not yet implemented - return default values
  return updateObject(state, {
    salesLoading: false,
    itemsSold: 0,
    pendingOrders: 0,
    totalProfit: 0,
  });
};

const getSalesActivityFail = (state, action) => {
  return updateObject(state, {
    salesLoading: false,
  });
};

const getInventorySummaryStart = (state, action) => {
  return updateObject(state, {
    inventoryLoading: true,
  });
};

const getInventorySummarySuccess = (state, action) => {
  // Dashboard endpoints not yet implemented - return default values
  return updateObject(state, {
    inventoryLoading: false,
    expiringItems: 0,
    itemsInStock: 0,
    stockValue: 0,
  });
};

const getInventorySummaryFail = (state, action) => {
  return updateObject(state, {
    inventoryLoading: false,
  });
};

const getSalesActivityGraphStart = (state, action) => {
  return updateObject(state, {
    graphLoading: true,
  });
};

const getSalesActivityGraphSuccess = (state, action) => {
  // Dashboard endpoints not yet implemented - return empty graph data
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  let GraphMetaData = {
    labels: [...monthNames],
    datasets: [
      {
        data: new Array(12).fill(0),
        backgroundColor: ["rgba(210, 244, 234, 1)"],
        borderColor: "#20C997",
        lineTension: 0,
      },
    ],
  };

  return updateObject(state, {
    graphLoading: false,
    GraphMetaData,
  });
};

const getSalesActivityGraphFail = (state, action) => {
  return updateObject(state, {
    graphLoading: false,
  });
};

const getProductsSaleStart = (state, action) => {
  return updateObject(state, {
    productsSaleLoading: true,
  });
};

const getProductsSaleSuccess = (state, action) => {
  // Dashboard endpoints not yet implemented - return empty array
  return updateObject(state, {
    productsSaleLoading: false,
    productsSale: [],
  });
};

const getProductsSaleFail = (state, action) => {
  return updateObject(state, {
    productsSaleLoading: false,
  });
};

const getPerformanceStart = (state, action) => {
  return updateObject(state, {
    performanceProductsSaleLoading: true,
  });
};

const getPerformanceSuccess = (state, action) => {
  // Dashboard endpoints not yet implemented - return empty array
  return updateObject(state, {
    performanceProductsSaleLoading: false,
    performanceProductsSale: [],
  });
};

const getPerformanceFail = (state, action) => {
  return updateObject(state, {
    performanceProductsSaleLoading: false,
  });
};

const getChartStart = (state, action) => {
  return updateObject(state, {
    chartLoading: true,
  });
};

const getChartSuccess = (state, action) => {
  // Dashboard endpoints not yet implemented - return empty chart data
  let chartData = {
    data: [],
    labels: [],
  };
  
  return updateObject(state, {
    chartLoading: false,
    chartData,
    chartList: [],
  });
};

const getChartFail = (state, action) => {
  return updateObject(state, {
    chartLoading: false,
  });
};

const reducer = (state = initaialState, action) => {
  switch (action.type) {
    case actionTypes.DASHBOARD_SALES_START:
      return getSalesActivityStart(state, action);
    case actionTypes.DASHBOARD_SALES_SUCCESS:
      return getSalesActivitySuccess(state, action);
    case actionTypes.DASHBOARD_SALES_FAIL:
      return getSalesActivityFail(state, action);
    case actionTypes.DASHBOARD_INVENTORY_START:
      return getInventorySummaryStart(state, action);
    case actionTypes.DASHBOARD_INVENTORY_SUCCESS:
      return getInventorySummarySuccess(state, action);
    case actionTypes.DASHBOARD_INVENTORY_FAIL:
      return getInventorySummaryFail(state, action);
    case actionTypes.DASHBOARD_SALES_GRAPH_START:
      return getSalesActivityGraphStart(state, action);
    case actionTypes.DASHBOARD_SALES_GRAPH_SUCCESS:
      return getSalesActivityGraphSuccess(state, action);
    case actionTypes.DASHBOARD_SALES_GRAPH_FAIL:
      return getSalesActivityGraphFail(state, action);
    case actionTypes.DASHBOARD_PRODUCTS_SALE_START:
      return getProductsSaleStart(state, action);
    case actionTypes.DASHBOARD_PRODUCTS_SALE_SUCCESS:
      return getProductsSaleSuccess(state, action);
    case actionTypes.DASHBOARD_PRODUCTS_SALE_FAIL:
      return getProductsSaleFail(state, action);
    case actionTypes.DASHBOARD_TOP_PERFORMANCE_START:
      return getPerformanceStart(state, action);
    case actionTypes.DASHBOARD_TOP_PERFORMANCE_SUCCESS:
      return getPerformanceSuccess(state, action);
    case actionTypes.DASHBOARD_TOP_PERFORMANCE_FAIL:
      return getPerformanceFail(state, action);
    case actionTypes.DASHBOARD_CHART_START:
      return getChartStart(state, action);
    case actionTypes.DASHBOARD_CHART_SUCCESS:
      return getChartSuccess(state, action);
    case actionTypes.DASHBOARD_CHART_FAIL:
      return getChartFail(state, action);
    default:
      return state;
  }
};

export default reducer;
